import {observer} from "mobx-react";
import Chip, {CHIP_COLORS} from "../../../../../components/chip/chip";
import {DRAFT_ORDER_STATE} from "../../rma-types";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface IDraftOrderStateChipProps {
    state: DRAFT_ORDER_STATE;
    isExchangeReleased: boolean;
}
const DraftOrderStateChip : React.FC<IDraftOrderStateChipProps> = observer(({state, isExchangeReleased})=> {
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-returns-rma-card';

    const getColor = (state: DRAFT_ORDER_STATE) => {
        switch (state){
            case DRAFT_ORDER_STATE.DRAFT_ORDER_CREATED:
            case DRAFT_ORDER_STATE.PENDING_PAYMENT:
            case DRAFT_ORDER_STATE.PENDING_INVOICE:
                return CHIP_COLORS.ORANGE;
            case DRAFT_ORDER_STATE.INVOICE_PAID:
                return CHIP_COLORS.GREEN;
        }
    }
    const getTranslationKey = (state: DRAFT_ORDER_STATE) => {
        if(isExchangeReleased){
            return 'RELEASED';
        }
        switch (state){
            case DRAFT_ORDER_STATE.DRAFT_ORDER_CREATED:
                return 'CREATED';
            case DRAFT_ORDER_STATE.PENDING_PAYMENT:
            case DRAFT_ORDER_STATE.PENDING_INVOICE:
                return 'PENDING';
            case DRAFT_ORDER_STATE.INVOICE_PAID:
                return 'PAID';
        }
    }
    return (
        <Chip color={getColor(state)} label={getTranslation(getTranslationKey(state), pageScope)}/>
    )
});

export default DraftOrderStateChip;